import { atom } from "recoil";

export const currentDeviceTab = atom<number>({
  key: "currentDeviceTab",
  default: 0,
});
